import { IDefineCommand, IQuery } from 'core-ts-types';
import { IRegisterSectionsDatasource } from '../datasources/register_sections_datasource';

export type ClearAllRegistrationSectionsCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'clearAllRegistrationSectionsCommand',
    (ngRegisterSectionsDatasource: IRegisterSectionsDatasource, defineCommandORM: IDefineCommand) => {
      return defineCommandORM('clearAllRegistrationSectionsCommand', (deferred) => {
        ngRegisterSectionsDatasource.clear();
        deferred.resolve();
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/commands/clear_all_registration_sections_command.ts